import styled from "@emotion/styled";
import { ListItemButton, Typography } from "@mui/material";
import { Button } from "@avenue-8/sidekick-ui";

export const PanelContainer = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 0;
  ${(p) => p.$disabled && "pointer-events: none;"}
`;

export const ViewStack = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const WorkflowPanelHeader = styled.div`
  width: 100%;
  text-align: left;
  padding-bottom: 0.5rem;
`;

export const PanelTitle = styled(Typography)`
  text-align: left;
  color: ${(p) => p.theme.text.colors.brand};
  width: 100%;
`;

export const Row = styled(ListItemButton)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: ${(p) => p.theme.colors.background};
  border-radius: 0.625rem;
  padding: 0.875rem 1rem;
  text-align: left;
  transition: background-color 0.15s ease;
  border: 1px solid transparent;

  &:hover {
    border-color: ${(p) => p.theme.colors.primary};
    background-color: ${(p) => p.theme.colors.background5};
  }
`;

export const RowIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.theme.text.colors.brand};
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;

  svg {
    font-size: 1.5rem;
  }
`;

export const RowLabel = styled(Typography)`
  font-weight: 600;
  font-size: ${(p) => p.theme.text.fontSizes.m};
  color: ${(p) => p.theme.text.colors.primary};
  flex: 1;
`;

export const BackRow = styled(Button)`
  padding: 0;
  align-self: flex-start;
  color: ${(p) => p.theme.button.outlined.colors.text};
`;
